/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetRestaurantMenusResult } from '../../models/get-restaurant-menus-result';

export interface GetByRestaurantidMenus$Params {
  RestaurantId: number;
}

export function getByRestaurantidMenus(
  http: HttpClient,
  rootUrl: string,
  params: GetByRestaurantidMenus$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetRestaurantMenusResult>> {
  const rb = new RequestBuilder(rootUrl, getByRestaurantidMenus.PATH, 'get');
  if (params) {
    rb.path('RestaurantId', params.RestaurantId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetRestaurantMenusResult>;
    }),
  );
}

getByRestaurantidMenus.PATH = '/Restaurants/{RestaurantId}/menus';
